import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import authStyles from '../styles/authStyles'

function Signup(props) {
  const { classes } = props

  return (
    <div className={classes.page}>
      <main className={classes.main}>
        <Paper className={classes.paper} elevation={0}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" className={classes.title}>
            個案註冊
          </Typography>
          <Typography className={classes.subtitle}>建立個案帳號</Typography>
          <form method="post" className={classes.form}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="email">電子郵件</InputLabel>
              <Input id="email" name="email" autoComplete="email" autoFocus />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">密碼</InputLabel>
              <Input
                name="password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </FormControl>
            <Input name="role" type="hidden" id="role" value="user_signup" />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              註冊
            </Button>
            <a style={{ textDecoration: 'none' }} href="/user/login">
              <Button fullWidth variant="outlined" color="primary" className={classes.submit}>
                登入
              </Button>
            </a>
          </form>
        </Paper>
      </main>
    </div>
  )
}

Signup.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(authStyles)(Signup)
